export enum SubscriptionType {
    Availability = 1,
    NewProducts,
    Both
}